export enum GuideState {
  Active = 1,
  Inactive = 2
};